import {onBeforeMount, Ref} from 'vue';
// import {LinkIndexInitLayoutData} from '../../common/LinkIndex';
import {SceneTreePanelInitLayoutData} from '../../../../types';
export interface SceneTreePanelProps {
	panelId: string;
	init_layout_data: SceneTreePanelInitLayoutData;
}

export function SetupLayoutData(
	props: SceneTreePanelProps,
	mask: Ref<string> /*, setupLinkIndexReturn: SetupLinkIndexReturn*/
) {
	onBeforeMount(() => {
		fromJSON(props.init_layout_data);
	});

	function fromJSON(json: SceneTreePanelInitLayoutData) {
		// setupLinkIndexReturn.fromJSON(json);
		if (json.mask) {
			mask.value = json.mask;
		}
	}

	function layoutData(): SceneTreePanelInitLayoutData {
		return {
			mask: mask.value,
			// ...setupLinkIndexReturn.toJSON(),
		};
	}

	return {fromJSON, layoutData};
}
